import React from 'react';

import {connect} from 'react-redux';

import {REVIEWS_POPUPS} from 'constants/popupNames';
import {ApplicationStoreType} from 'desktop/store';

import {getActivePopup} from '../../store/selectors/orderLast/orderLast';
import {ReviewsSelectedPopupType} from '../../types/types';
import {SiteJabber} from '../siteJabber/siteJabber';
import {TrustPilotConnected} from '../trustPilot/trustPilot';

const popups: {[key: string]: React.ReactElement | string} = {
    [REVIEWS_POPUPS.SITEJABBER]: <SiteJabber />,
    [REVIEWS_POPUPS.TRUST_PILOT]: <TrustPilotConnected />,
};

type PropsType = {
    popup: ReviewsSelectedPopupType;
};

/**
 * Container for reviews popups
 * @param {PropsType} - props
 * @constructor
 */
export const ReviewsPopups: React.FC<PropsType> = ({popup}) => {
    if (!popups[popup]) return null;
    return popups[popup];
};

/**
 * Map state to props
 * @param {ApplicationStoreType} state - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (state: ApplicationStoreType) => ({
    popup: getActivePopup(state),
});

export const ReviewsPopupsConnected = connect(mapStateToProps)(ReviewsPopups);
